var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.notification.type,"timeout":_vm.notification.timeout,"multi-line":""},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.setNotification({
                    show: false,
                    type: _vm.notification.type,
                    text: _vm.notification.text,
                })}}},[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.icons.mdiClose)}})],1)]},proxy:true}]),model:{value:(_vm.notification.show),callback:function ($$v) {_vm.$set(_vm.notification, "show", $$v)},expression:"notification.show"}},[_c('v-icon',{staticClass:"mr-1",domProps:{"textContent":_vm._s(
            _vm.notification.type === 'success'
                ? _vm.icons.mdiCheckCircle
                : _vm.icons.mdiAlert
        )}}),_c('span',{staticClass:"subtitle-1 font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.notification.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }